import { Helmet } from 'react-helmet';
import { defaultMeta, pagesMeta } from '../data/seoConfig';

export const SEO = ({ 
  page,
  title,
  description,
  keywords,
  author,
  image,
  url,
  type,
  siteName
}) => {
  const pageData = (page && pagesMeta[page]) ? pagesMeta[page] : {};

  const metaSiteName = siteName || pageData.siteName || defaultMeta.siteName;
  const metaTitle = title || pageData.title || defaultMeta.title;
  const metaDescription = description || pageData.description || defaultMeta.description;
  const metaKeywords = keywords || pageData.keywords || defaultMeta.keywords;
  const metaAuthor = author || pageData.author || defaultMeta.author;
  const metaImage = image || pageData.image || defaultMeta.image;
  const metaUrl = url || pageData.url || defaultMeta.url;
  const metaType = type || pageData.type || defaultMeta.type;

  const siteTitle = metaTitle.includes("Aadarsh") ? metaTitle : `${metaTitle} | Aadarsh Rajesh Kumar`;
  
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{siteTitle}</title>
      <meta name="title" content={siteTitle} />
      <meta name="description" content={metaDescription} />
      <meta name="keywords" content={metaKeywords} />
      <meta name="author" content={metaAuthor} />
      <meta name="robots" content="index, follow" />
      <meta name="language" content="English" />
      <meta name="revisit-after" content="7 days" />
      
      {/* Favicon */}
      <link rel="icon" type="image/svg+xml" href={defaultMeta.favicon} sizes="any" />
      <link rel="apple-touch-icon" href={defaultMeta.favicon} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={metaType} />
      <meta property="og:url" content={metaUrl} />
      <meta property="og:title" content={siteTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={metaImage} />
      <meta property="og:site_name" content={metaSiteName} />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={metaUrl} />
      <meta property="twitter:title" content={siteTitle} />
      <meta property="twitter:description" content={metaDescription} />
      <meta property="twitter:image" content={metaImage} />
      
      {/* Additional SEO */}
      <link rel="canonical" href={metaUrl} />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
      
      {/* JSON-LD Schema for Site Name */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebSite",
          "name": metaSiteName,
          "url": "https://aadarshrajesh.page"
        })}
      </script>

      {/* JSON-LD Schema for FAQ */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": [{
            "@type": "Question",
            "name": "What makes Aadarsh a top digital marketing specialist in Thiruvalla, Kerala?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Aadarsh stands out as a digital marketing expert in Thiruvalla for his personalized approach to online strategies. With a deep understanding of the digital landscape, he helps businesses create unique campaigns tailored to their goals. His expertise extends beyond Thiruvalla, making him a trusted name across India."
            }
          },{
            "@type": "Question",
            "name": "Does Aadarsh provide digital marketing services outside Thiruvalla and Kerala?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Yes, Aadarsh's digital marketing services are not confined to Thiruvalla or Kerala. His reputation as a skilled strategist has earned him clients from all over India and beyond. Whether you're a local business or an international brand, his solutions are designed to deliver measurable results."
            }
          },{
            "@type": "Question",
            "name": "Can Aadarsh integrate website development with SEO strategies?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Absolutely. Aadarsh ensures that every website he develops aligns with modern SEO practices. This integration creates a seamless experience for both users and search engines, resulting in a site that performs well and captures attention."
            }
          },{
            "@type": "Question",
            "name": "What is involved in your SEO Optimization process?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "I implement comprehensive SEO strategies to improve search rankings, organic traffic, and online visibility. This includes Keyword Research, On-page SEO, Technical SEO, Analytics & Reporting, AEO (Answer Engine Optimization), and GEO (Generative Engine Optimization)."
            }
          },{
            "@type": "Question",
            "name": "How can businesses get in touch with Aadarsh for digital marketing services?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "You can send a quick message on WhatsApp to start a conversation, drop an email for detailed project inquiries, or connect with him on LinkedIn to network and follow his latest digital marketing insights."
            }
          }]
        })}
      </script>
    </Helmet>
  );
};
